// Navigation: mobile drawer menu, sidebar menu toggles and megamenu
export default function () {

    const $ = jQuery;

    // Reset all submenus
    function resetDrawerMenu() {
        $('.drawer__menu-sub').removeClass('is-active');
    }

    // Toggle drawer open/close
    $('[data-mobile-menu="hamburger"]').click(function () {
        const $drawer = $('[data-menu="main"]');
        const $overlay = $('.overlay');

        const isOpen = $drawer.hasClass('is-open');

        // Toggle only the drawer and overlay
        $drawer.toggleClass('is-open');
        $overlay.toggleClass('is-open');

        // If closing the menu, reset all submenus
        if (isOpen) {
            resetDrawerMenu();
        }
    });

    // Open a submenu
    $('.drawer__menu li.has-submenu > .depth').click(function () {
        const $submenu = $(this).next('.drawer__menu-sub');

        if ($submenu.length) {
            $submenu.addClass('is-active');
        }
    });

    // Return to previous menu
    $('.drawer__menu-return').click(function () {
        const $currentSub = $(this).closest('.drawer__menu-sub');

        $currentSub.removeClass('is-active');

        const $parentSub = $currentSub.parents('.drawer__menu-sub').first();

        if ($parentSub.length) {
            $parentSub.addClass('is-active');
        }
    });

    $('[data-action="drawer__menu-close"]').click(function () {
        const $drawer = $('[data-menu="main"]');
        const $overlay = $('.overlay');
        if (!$drawer.hasClass('is-open')) return;
        if (!$overlay.hasClass('is-open')) return;


        $overlay.toggleClass('is-open');
        $drawer.removeClass('is-open');
        resetDrawerMenu();
    });

    // Close the drawer when clicking outside the menu
    $(document).on('click', function (event) {
        const $drawer = $('[data-menu="main"]');
        const $overlay = $('.overlay');

        // If menu is not open, do nothing
        if (!$drawer.hasClass('is-open')) return;

        // If click is outside the drawer and not on the hamburger
        if (
            !$drawer.is(event.target) &&
            $drawer.has(event.target).length === 0 &&
            !$(event.target).closest('[data-mobile-menu="hamburger"]').length
        ) {
            $overlay.toggleClass('is-open');
            $drawer.removeClass('is-open');
            resetDrawerMenu();
        }
    });

    // Open the submenu of the current page in the sidebar menu
    var currentUrl = window.location.href.split(/[?#]/)[0];

    $('[data-action="toggle_menu"]').each(function () {
        var $toggle = $(this);
        var $link = $toggle.find('a');
        var href = $link.attr('href');

        if (href && href.replace(/\/$/, '') === currentUrl.replace(/\/$/, '')) {
            var $li = $toggle.closest('li');

            $li.addClass('is-active');
            $li.children('.sub-menu').stop(true, true).slideDown(250, 'swing');
        }
    });

    $(document).on('click', '[data-action="toggle_menu"]', function (e) {
        var $li = $(this).closest('li');
        $li.toggleClass('is-active');
        $li.children('.sub-menu').stop(true, true).slideToggle(250, 'swing');
    });

    // Megamenu: show links panel of the hovered nav item
    $('.megamenu__nav li[data-id]').on('mouseenter', function () {
        const menuId = $(this).data('id');

        $('.megamenu__nav li').removeClass('active');
        $(this).addClass('active');

        $('.megamenu__links[data-for]').removeClass('active').hide();
        $(`.megamenu__links[data-for="${menuId}"]`).addClass('active').show();
    });

}
